<div class="pott product-type" *ngIf="showToolTip(0, 0)">
  <h5>Product Type</h5>
  <ul>
    <li><span>C</span>Combined gas and particle</li>
    <li><span>G</span>Gas only pod</li>
    <li><span>P</span>Particle only</li>
  </ul>
</div>
<div class="pott gas-channel" *ngIf="showToolTip(1, 1)">
  <h5>Gas Channel</h5>
  <ul>
    <li><span>0</span>None</li>
    <li><span>1</span>NO (NO + NO2 for NOx)</li>
    <li><span>2</span>NO2</li>
    <li><span>3</span>O3 (Requires NO2)</li>
    <li><span>4</span>CO</li>
    <li><span>5</span>SO2 (Requires NO2)</li>
    <li><span>6</span>H2S (Replaces CO/SO2)</li>
    <li><span>7</span>TVOC (EO) (Replaces NO, Requires CO)</li>
    <li><span>8</span>NH3 (Replaces NO)</li>
  </ul>
</div>
<div class="pott gas-channel" *ngIf="showToolTip(2, 5)">
  <h5>Gas Channel</h5>
  <ul>
    <li><span>0</span>None</li>
    <li><span>1</span>NO (NO + NO2 for NOx)</li>
    <li><span>2</span>NO2</li>
    <li><span>3</span>O3 (Requires NO2)</li>
    <li><span>4</span>CO</li>
    <li><span>5</span>SO2 (Requires NO2)</li>
    <li><span>6</span>H2S (Replaces CO/SO2)</li>
    <li><span>7</span>TVOC (EO) (Replaces NO, Requires CO)</li>
    <li><span>8</span>NH3 (Replaces NO)</li>
  </ul>
</div>
<div class="pott" *ngIf="showToolTip(6, 6)">
  <h5>- Separator</h5>
</div>
<div class="pott uart-option" *ngIf="showToolTip(7, 7)">
  <h5>UART Option</h5>
  <ul>
    <li><span>0</span>None</li>
    <li><span>1</span>CO2 (ppm) requires D/C2</li>
    <li><span>2</span>CH4 (ppm) MEMS, - caution: reduces battery life: use battery calculator</li>
    <li><span>3</span>CH4 (ppm) TDL, requires D/C (fixed supply only)</li>
  </ul>
</div>
<div class="pott aux1-options" *ngIf="showToolTip(8, 8)">
  <h5>AUX1 Options</h5>
  <ul>
    <li><span>0</span>None</li>
    <li><span>1</span>VOC (ppm) requires D/C2</li>
    <li><span>2</span>Wind Speed (m/s) requires D/C1</li>
    <li><span>3</span>Solar Radiation (W/m2) requires D/C1</li>
  </ul>
</div>
<div class="pott aux2-options" *ngIf="showToolTip(9, 9)">
  <h5>AUX2 Options</h5>
  <ul>
    <li><span>0</span>None</li>
    <li><span>1</span>VOC (ppm) requires D/C2</li>
    <li><span>2</span>Wind Direction (Degrees) requires D/C1</li>
  </ul>
</div>
<div class="pott noise-option" *ngIf="showToolTip(10, 10)">
  <h5>Noise Option</h5>
  <ul>
    <li><span>0</span>None</li>
    <li><span>1</span>Noise sensor (db) Average and Peak (reduces battery life): use battery calculator</li>
  </ul>
</div>
<div class="pott" *ngIf="showToolTip(11, 11)">
  <h5>- Separator</h5>
</div>
<div class="pott power-options" *ngIf="showToolTip(12, 12)">
  <h5>Power Options</h5>
  <ul>
    <li><span>0</span>No Battery supplied</li>
    <li><span>1</span>Internal Lithium Battery pack (special request only, 3v3 supply)</li>
    <li><span>2</span>External Power (12V, MeanWell PSU) use appropirate D/C option i.e. D/C2+ for standard or D/C1 for wind</li>
    <li><span>3</span>External Power (12V, MeanWell PSU) Heated inlet D/C1 (AC mains supply only).</li>
    <li><span>4</span>External Battery (High capacity lithium pack, 3v3 supply)</li>
    <li><span>5</span>NiMh rechargeable (internal battery NiMh, 3v3 supply) supplier with 2 x battey pack plus charger.</li>
    <li><span>6</span>External Power (12V), Using EI 20W Solar (battery voltage monitor AUX4) D/C2+ (or D/C1 wind).</li>
    <li><span>7</span>External Power (12V), Using customer's solar panel D/C2+ (or D/C1 for wind).</li>
    <li><span>9</span>PoE (Power over Ethernet)</li>
  </ul>
</div>
<div class="pott special-build" *ngIf="showToolTip(13, 13)">
  <h5>Special Build</h5>
  <ul>
    <li><span>Blank</span>None</li>
    <li><span>A</span>Pumped Manifold, No GPS for Future Decsions.</li>
    <li><span>B</span>Fast transmission option.</li>
    <li><span>C</span>Ethernet Comms (non PoE) prototype sales only</li>
    <li><span>D</span>LE910 modem (2G, 3G and 4G LTE CAT1) where 5G LTE CAT1M is not available</li>
    <li><span>E</span>Ventus Pump</li>
    <li><span>F</span>Trickle charger (12V supply)</li>
    <li><span>G</span>Pumped Manifold and Ventus pump</li>
  </ul>
</div>
